export const CONVERSATION_SUMMARY_GATE = 'Communication:AI:ConversationSummary';
export const USER_SETUP_WORKING_HOURS = 'userSetup:workingHours';
export const USER_OUT_OF_OFFICE = 'Routing:UserOutOfOffice';
export const LIMITED_TICKET_FUNCTION = 'HelpDesk:LimitedTicketFunctionInInbox';
export const CONVERSATION_TICKET_STATUS_CONDITIONAL_PROPERTIES = 'Conversations:TicketStatusConditionalProperties';
export const HELP_DESK_ROUTING_SCOPE_FILTERING = 'HelpDeskRoutingScopeFiltering';
export const ROUTING_REASSIGNMENT_CHIRP = 'Routing:ReassignmentCHIRP';
export const MOBILE_CHAT_SDK = 'Conversations:MobileChatSDK';